import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpStatusCode, ResponseModel } from '../Shared/model/response.model';
import { ApiDataService } from '../Shared/services/apidata.service';
import { ActivatedRoute } from '@angular/router';
// import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-casestudydetails',
  templateUrl: './casestudydetails.component.html',
  styleUrls: ['./casestudydetails.component.scss']
})
export class CasestudydetailsComponent implements OnInit {
  CaseStudyDetail:any;
  id = 0;
  constructor(
    // private  dialogRef:  MatDialogRef<CasestudydetailsComponent>,
    //  @Inject(MAT_DIALOG_DATA)
    //  public  data:  any ,
     private apiservice:ApiDataService,
  private route:ActivatedRoute) {
  }
  ngOnInit(): void {
    this.id = this.route.snapshot.params.id;
    // console.log(this.data)
    this.getCasestudyDetails();
  }

  // public  closeMe() {
  //     this.dialogRef.close();
  // }
  getCasestudyDetails() {
    const url = `CaseStudy/GetCaseStudyDetails?id=${this.id}`;
    // const url = `CaseStudy/GetCaseStudyDetails?id=${this.data.id}`;
    this.apiservice.getData(url).subscribe((response: ResponseModel<any>) => {
      if (response.status === HttpStatusCode.OK) {
        this.CaseStudyDetail = response.data;
      }
    });
  }
}
